export default {

  setLayout({ commit }, payload) {
    commit('setLayout', payload)
    localStorage.setItem("flyvendas:layoutData", JSON.stringify(payload))
  }

}
